import { Injectable } from '@angular/core';
import { TicketActionsApiService } from './ticket-actions-api.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomToastService } from '../custom-toast.service';
import { TicketStateService } from './ticket-state.service';
import { Ticket } from 'src/app/models/core/ticket.model';

@Injectable({
  providedIn: 'root'
})
export class TicketActionsService {

  constructor(
    private readonly api: TicketActionsApiService,
    private readonly _translate: TranslateService,
    private customToast: CustomToastService,
    private ticketStateService: TicketStateService
  ) { }

  async sendEditPetition(data: any, onSuccess: () => void) {
    try {
      const res = await this.api.sendEditPetition(data).toPromise();

      if (res?.status == '200') {
        onSuccess();
        this.customToast.show(this._translate.instant('edit-ticket-modal.success-message'), 3000, 'success');
      } else {
        this.customToast.show(this._translate.instant('edit-ticket-modal.error-message'), 3000, 'error');
      }
    } catch (err) {
      console.error(err);
      this.customToast.show(this._translate.instant('edit-ticket-modal.unknown-error'), 3000, 'error');
    }
  }

  showError(key: string) {
    this.customToast.show(this._translate.instant(key), 3000, 'error');
  }

  async deleteTicket(ticketId: number, onSuccess: () => void) {
    try {
      const res = await this.api.deleteTicket(ticketId).toPromise();

      if (res?.status === true || res?.status === '200') {
        onSuccess();
        this.customToast.show(this._translate.instant('delete-ticket-modal.success-message'), 3000, 'success');
      } else {
        this.customToast.show(this._translate.instant('delete-ticket-modal.error-message'), 3000, 'error');
      }

    } catch (err: any) {
      console.error(err);
      if (err?.status === 422) {
        this.customToast.show(err?.error?.message || this._translate.instant('delete-ticket-modal.validation-error'), 3000, 'error');
      } else {
        this.customToast.show(this._translate.instant('delete-ticket-modal.unknown-error'), 3000, 'error');
      }
    }
  }

  async sendDeletePetition(data: any, onSuccess: () => void) {
    try {
      const res = await this.api.sendDeletePetition(data).toPromise();

      if (res?.status == '200') {
        onSuccess();
        this.customToast.show(this._translate.instant('delete-ticket-modal.success-petition-message'), 3000, 'success');
      } else {
        this.customToast.show(this._translate.instant('delete-ticket-modal.error-petition-message'), 3000, 'error');
      }
    } catch (err) {
      console.error(err);
      this.customToast.show(this._translate.instant('edit-ticket-modal.unknown-error'), 3000, 'error');
    }
  }

  async generateTicket(data: any): Promise<Ticket> {
    try {
      const res = await this.api.generateTicket(data).toPromise();
      if (res?.uuid) {
        this.customToast.show(
          this._translate.instant('generate-ticket-modal.success'),
          2000,
          'success'
        );
        this.ticketStateService.notifyTicketGenerated(res, data.product_id);
        return res;
      } else {
        this.customToast.show(this._translate.instant('generate-ticket-modal.error'), 3000, 'error');
        throw new Error('Ticket generation failed');
      }
    } catch (err: any) {
      console.error(err);
      if (err?.status === 422) {
        this.customToast.show(err?.error?.message || this._translate.instant('generate-ticket-modal.validation-error'), 3000, 'error');
      } else {
        this.customToast.show(this._translate.instant('generate-ticket-modal.unknown-error'), 3000, 'error');
      }
      throw err;
    }
  }

}
